import moment from "moment";

import BackEndService from "../api/BackEndService";
import JobService from "../api/JobService";
import { Appointment } from "../types/appointment";
import { JobState } from "../types/job";
import { ClockodoUser } from "../types/user";


export type ServiceEventType =
  | "start"
  | "pause"
  | "resume"
  | "stop";

export const handleServiceEvent = async (
  appointment: Appointment,
  eventType: ServiceEventType,
  clockodoUser: ClockodoUser | null,
  user?: {
    id: string;
    type: string;
  }
) => {
  if (!user?.id) {
    throw new Error("User is not available");
  }

  if (!appointment?.id) {
    throw new Error("Appointment is not available");
  }

  try {
    const now = moment().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

    const data = {
      employeeId: user.id,
      appointmentId: appointment.id,
      eventTimestamp: now,
      eventType,
      mileage: clockodoUser?.lastEndingMileage,
      errorMsg: "mollit dolore laboris cupidatat",
      createdAt: now,
      updatedAt: now,
    };

    await BackEndService.AddTimeTrackingEvent(data);

    const jobId = appointment?.jobs?.slice(-1).pop()?.id;

    if (jobId) {
      const jobState: JobState =
        eventType === "stop"
          ? "processing"
          : "partlyProcessed";

      await JobService.UpdateJob(jobId, {
        jobState,
      });
    }
  } catch (error) {
    console.error("Failed to handle service event:", error);

    throw error;
  }
};
